
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/home",
      function () {
        return require("private-next-pages/fr/home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/home"])
      });
    }
  